<template>
  <layout>
    <h1>{{ $t('pages.reset.title') }}</h1>
    <p>{{ $t('pages.reset.explain') }}</p>
    <reset-form :token="token" :success_route="{ name: 'home' }" uri="api/public/resetting/reset" />
  </layout>
</template>

<script>
  import Layout from '@/views/Default/Layout';
  import ResetForm from '@triotech/vue-core/src/components/authentification/AjaxChange';

  export default {
    name: 'ResetPage',
    components: {
      ResetForm,
      Layout,
    },
    props: {
      token: {
        type: String,
        default: '',
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/views/Authentification/reset.vue